import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'constants/routes';
import { X_PATH } from 'constants/xPath';
import useAuthentication from 'hooks/useAuthentication';
import AccountMenu from '#web-components/components/AccountMenu';
import MenuItem from '#web-components/components/MenuList/components/MenuItem';
import Divider from '#web-components/components/Divider';
import styles from './Menu.styles';

const useStyles = makeStyles(styles, { name: 'Menu' });
export default function Menu() {
  const authentication = useAuthentication();
  const history = useHistory();
  const userInfo = authentication.info;
  const classes = useStyles();
  const { t } = useTranslation('components');

  const handleLogout = useCallback((): void => {
    authentication.logout();
  }, [authentication]);

  const handleNavigateTo = useCallback((path: string) => () => {
    history.push(path);
  }, [history]);

  if (!(authentication.authenticated)) {
    return null;
  }

  const accountName = `${userInfo?.given_name} ${userInfo?.family_name && userInfo?.family_name.charAt(0)}.`;

  return (
    <AccountMenu
      name={accountName}
    >
      <div>
        {userInfo?.name && (
          <MenuItem className={classes.menuItem}>
            {userInfo.name}
          </MenuItem>
        )}
        <MenuItem onClick={handleNavigateTo(ROUTES.PROFILE)} className={classes.menuItem}>
          {t('header.profile')}
        </MenuItem>
        <Divider className={classes.divider} />
        <MenuItem
          data-xpath={X_PATH.logout}
          onClick={handleLogout}
        >
          {t('header.logout')}
        </MenuItem>
      </div>
    </AccountMenu>
  );
}
